import React from 'react'

import './homevideo.css'
import video from '../../assets/background.mp4'

const Homevideo = () => {
  return (
      <div className='lsk__homevideo'>
        <div className='lsk__homevideo-video'>
          <video id="background-vd" autoPlay loop muted className='lsk__video-home'>
              <source src={video} type="video/mp4"></source>
          </video>
        </div>  
        <div className='lsk__homevideo-text'>
            <h1 className="lsk__title">Problemas com arquitetura e gestão de infraestrutura de T.I. ?</h1>
            <h2 className="lsk__subtitle">Chegou ao lugar certo.</h2>
            <h2 className="lsk__subtitle">Vamos construir algo excepcional juntos?</h2>
            <span className='lsk__homevideo-container-content-button'>
                <button type='button'>Fale Conosco </button>
            </span>
        </div>
      </div>
  )
}

export default Homevideo